import { createFilledIcon } from '@ps/ds/icons/helpers/createFilledIcon'

export const TipFilled = createFilledIcon(
  'TipFilled',
  [
    [
      'path',
      {
        d: 'M12.3113 23C11.8713 23 11.4946 22.8433 11.1813 22.53C10.8679 22.2167 10.7113 21.84 10.7113 21.4H13.9113C13.9113 21.84 13.7546 22.2167 13.4413 22.53C13.1279 22.8433 12.7513 23 12.3113 23ZM9.91128 20.6C9.68461 20.6 9.49461 20.5233 9.34128 20.37C9.18795 20.2167 9.11128 20.0267 9.11128 19.8C9.11128 19.5733 9.18795 19.3833 9.34128 19.23C9.49461 19.0767 9.68461 19 9.91128 19H14.7113C14.9379 19 15.1279 19.0767 15.2813 19.23C15.4346 19.3833 15.5113 19.5733 15.5113 19.8C15.5113 20.0267 15.4346 20.2167 15.2813 20.37C15.1279 20.5233 14.9379 20.6 14.7113 20.6H9.91128ZM9.31128 18.2C8.39128 17.6533 7.66128 16.92 7.12128 16C6.58128 15.08 6.31128 14.08 6.31128 13C6.31128 11.3333 6.89461 9.91667 8.06128 8.75C9.22795 7.58333 10.6446 7 12.3113 7C13.9779 7 15.3946 7.58333 16.5613 8.75C17.7279 9.91667 18.3113 11.3333 18.3113 13C18.3113 14.08 18.0413 15.08 17.5013 16C16.9613 16.92 16.2313 17.6533 15.3113 18.2H9.31128Z',
        stroke: 'none',
        key: 'TipFilled-0',
      },
    ],
    [
      'path',
      {
        d: 'M5.88575 6.76596L5.54532 6.42553C5.38929 6.2695 5.31128 6.07092 5.31128 5.82979C5.31128 5.58865 5.38929 5.39007 5.54532 5.23404C5.70135 5.07801 5.89993 5 6.14107 5C6.3822 5 6.58078 5.07801 6.73681 5.23404L7.07724 5.57447C7.23326 5.7305 7.31128 5.92908 7.31128 6.17021C7.31128 6.41135 7.23326 6.60993 7.07724 6.76596C6.92121 6.92199 6.72263 7 6.48149 7C6.24036 7 6.04178 6.92199 5.88575 6.76596Z',
        stroke: 'none',
        key: 'TipFilled-1',
      },
    ],
    [
      'path',
      {
        d: 'M11.5838 3.69826L11.5577 3.21753C11.5457 2.9972 11.6202 2.79728 11.7812 2.61776C11.9422 2.43824 12.1329 2.34248 12.3532 2.3305C12.5735 2.31851 12.7734 2.39301 12.953 2.55401C13.1325 2.715 13.2282 2.90566 13.2402 3.12599L13.2664 3.60672C13.2784 3.82705 13.2039 4.02697 13.0429 4.20649C12.8819 4.38601 12.6912 4.48176 12.4709 4.49375C12.2506 4.50574 12.0506 4.43124 11.8711 4.27024C11.6916 4.10925 11.5958 3.91859 11.5838 3.69826Z',
        stroke: 'none',
        key: 'TipFilled-2',
      },
    ],
    [
      'path',
      {
        d: 'M18.4255 6.76596L18.766 6.42553C18.922 6.2695 19 6.07092 19 5.82979C19 5.58865 18.922 5.39007 18.766 5.23404C18.6099 5.07801 18.4113 5 18.1702 5C17.9291 5 17.7305 5.07801 17.5745 5.23404L17.234 5.57447C17.078 5.7305 17 5.92908 17 6.17021C17 6.41135 17.078 6.60993 17.234 6.76596C17.3901 6.92199 17.5887 7 17.8298 7C18.0709 7 18.2695 6.92199 18.4255 6.76596Z',
        stroke: 'none',
        key: 'TipFilled-3',
      },
    ],
    [
      'path',
      {
        d: 'M3.47408 13.2496L2.97589 13.1133C2.74755 13.0508 2.56929 12.9073 2.4411 12.6826C2.31292 12.4578 2.28005 12.2313 2.34251 12.003C2.40496 11.7746 2.54854 11.5964 2.77325 11.4682C2.99796 11.34 3.22448 11.3072 3.45282 11.3696L3.95101 11.5059C4.17935 11.5683 4.35761 11.7119 4.4858 11.9366C4.61398 12.1613 4.64685 12.3878 4.58439 12.6162C4.52194 12.8445 4.37836 13.0228 4.15365 13.151C3.92895 13.2791 3.70242 13.312 3.47408 13.2496Z',
        stroke: 'none',
        key: 'TipFilled-4',
      },
    ],
    [
      'path',
      {
        d: 'M21.0872 13.5321L21.5848 13.3936C21.8128 13.3301 21.9904 13.1857 22.1176 12.9604C22.2447 12.7351 22.2766 12.5085 22.2131 12.2804C22.1496 12.0524 22.0052 11.8748 21.7799 11.7476C21.5546 11.6204 21.328 11.5886 21.0999 11.6521L20.6024 11.7906C20.3743 11.8541 20.1967 11.9985 20.0695 12.2238C19.9424 12.4491 19.9105 12.6757 19.974 12.9038C20.0375 13.1318 20.1819 13.3094 20.4072 13.4366C20.6325 13.5638 20.8591 13.5956 21.0872 13.5321Z',
        stroke: 'none',
        key: 'TipFilled-5',
      },
    ],
  ],
  {
    defaultGradient: 'orange',
  },
)

TipFilled.displayName = 'TipFilled'
